import { memo } from 'react';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { FormattedMessage } from 'react-intl';

export const Loading = memo(() => (
    <Spinner text={<FormattedMessage id='intl-msg:drivers.spinner.loading' defaultMessage='Loading drivers...' />} />
));
